import { environment } from 'src/environments/environment';
import { SolitaireApp } from '../solitaire-app';
import { GameMainScene } from 'src/games/common/phaser/game/scenes/game-main-scene';
import { GameSizeMetrics } from 'src/games/common/phaser/game/scenes/scaled-base-scene';

export class SolitaireMainScene extends GameMainScene {
  public static get className(): string {
    return SolitaireMainScene.name;
  }

  constructor() {
    super({ key: SolitaireMainScene.className, active: false });
  }

  public override showStartButton(showButton: boolean): void {
    SolitaireApp.getInstance().gameController.showStartButton(showButton);
  }

  public override startRound(moves: string[], logicVersion: number): void {
    SolitaireApp.getInstance().gameController.startRemoteRound(moves, logicVersion);
  }

  public override setInstantFinish(): void {
    SolitaireApp.getInstance().gameController.setInstantFinish();
  }

  public override autoStartGame(): void {
    SolitaireApp.getInstance().gameController.autoStartGame();
  }

  public override resetGameScene(): void {
    SolitaireApp.getInstance().gameController.resetGameScene();
  }

  public hint(): void {
    SolitaireApp.getInstance().gameController.hint();
  }

  public undo(): void {
    SolitaireApp.getInstance().gameController.undo();
  }

  protected override initGraphics() {
    super.initGraphics();

    if (!environment.production) {
      // this.createDebugHelpers();
    }

    SolitaireApp.getInstance().gameController.initGraphics(this);
  }

  protected override onResize(gameSizeMetrics: GameSizeMetrics): void {
    SolitaireApp.getInstance().gameController.onResize(gameSizeMetrics);
  }

  protected override onSceneReady(key: string) {
    super.onSceneReady(key);

    if (key === SolitaireMainScene.className) {
      SolitaireApp.getInstance().gameController.onSceneReady();
    }
  }

  private createDebugHelpers() {
    this.time.addEvent({
      delay: 2500,
      loop: true,
      callback: () => {
        console.info(`Display List: count: ${this.sys.displayList.list.length}`);
        //console.table(this.sys.displayList.list, ['name', 'type', 'x', 'y', 'active']);
      },
    });
  }
}
